const HAS_SEEN_VALET_KEY_PREFIX = "hasSeenValetModal-";
export const HAS_SEEN_VALET_VALUE = "true";
const LAST_HARD_RELOAD_KEY = "lastHardReload";
const APP_TO_BACKGROUND_AT_KEY = "appToBackgroundAt";

export const getUserHasSeenValetModal = (email?: string, localStorage: any = window.localStorage): boolean => {
    return email && localStorage.getItem(`${HAS_SEEN_VALET_KEY_PREFIX}${email}`) ? true : false;
};

export const setUserHasSeenValetModal = (email?: string, localStorage: any = window.localStorage): void => {
    localStorage.setItem(`${HAS_SEEN_VALET_KEY_PREFIX}${email}`, HAS_SEEN_VALET_VALUE);
};

export const resetUserHasSeenValetModal = (email?: string, localStorage: any = window.localStorage): void => {
    localStorage.removeItem(`${HAS_SEEN_VALET_KEY_PREFIX}${email}`);
};

export const getLastHardReload = (localStorage: any = window.localStorage): number => {
    return Number(localStorage.getItem(LAST_HARD_RELOAD_KEY) || 0);
};

export const setLastHardReload = (timestamp: number, localStorage: any = window.localStorage): void => {
    localStorage.setItem(LAST_HARD_RELOAD_KEY, String(timestamp));
};

export const getAppToBackgroundAt = (localStorage: any = window.localStorage): number => {
    return Number(localStorage.getItem(APP_TO_BACKGROUND_AT_KEY) || 0);
};

export const setAppToBackgroundAt = (timestamp: number, localStorage: any = window.localStorage): void => {
    localStorage.setItem(APP_TO_BACKGROUND_AT_KEY, String(timestamp));
};

export const resetAppToBackgroundAt = (localStorage: any = window.localStorage): void => {
    localStorage.removeItem(APP_TO_BACKGROUND_AT_KEY);
};
